export default __webpack_public_path__ + "static/media/problem.fbc1ad6a.jpg";